import React, { useState, useEffect } from 'react';
import { 
  Link
} from '@cloudscape-design/components';
import { BaseTable } from './BaseTable';
import { useLocalStorage } from '../commons/use-local-storage';
import { FullPageHeader } from '../commons';
import { StatusComponent } from './table-select-filter-components';
import { submissionsApi  } from 'api/Submission';

const RequestStatus = {
  PENDING: 'pending',
  REJECTED: 'rejected',
  ENDED: 'ended',
  ONGOING: 'ongoing'
};

const defaultStatus = { value: '0', label: 'All Status' };

const COLUMN_DEFINITIONS = [
  {
    id: 'id',
    header: 'Request ID',
    cell: item => (
      <Link 
        href={`/my-requests/${item.id}`}
        className="text-blue-600 hover:text-blue-800 underline"
      >
        {item.id}
      </Link>
    ),
  },
  {
    id: 'user_email',
    header: 'User Email',
    cell: item => item.user_email,
  },
  {
    id: 'create_datetime',
    header: 'Created',
    cell: item => new Date(item.create_datetime).toLocaleString(),
  },
  {
    id: 'start_datetime',
    header: 'Start Time',
    cell: item => new Date(item.start_datetime).toLocaleString(),
  },
  {
    id: 'end_datetime',
    header: 'End Time',
    cell: item => new Date(item.end_datetime).toLocaleString(),
  },
  {
    id: 'status',
    header: 'Status',
    cell: item => <StatusComponent status={item.status} />,
  }
];

const STATUS_OPTIONS = [
  defaultStatus,
  ...Object.entries(RequestStatus).map(([key, value], index) => ({
    label: value,
    value: (index + 1).toString()
  }))
];

export function UserRequestsTable() {
  const [data, setData] = useState([]);
  const [statusFilter, setStatusFilter] = useState(defaultStatus);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadMoreIsVisible, setLoadMoreIsVisible] = useState(true);


  const [preferences, setPreferences] = useLocalStorage('Request-Table-Preferences', {
    pageSize: 10,
    wrapLines: false,
    stripedRows: false,
    contentDensity: 'comfortable',
  });

  const fetchData = async () => {
    try {
      const params = {
        limit: preferences.pageSize,
      };
  
      if (lastEvaluatedKey) {
        params.last_evaluated_key = lastEvaluatedKey;
      }
  
      if (statusFilter.value !== '0') {
        params.status = statusFilter.label;
      }
  
      const result = await submissionsApi.listMyRequests(params);

      if (lastEvaluatedKey) {
        setData(prev => [...prev, ...result.items]);
      } else {
        setData(result.items);
      }
      setLoadMoreIsVisible(result.last_evaluated_key !== null);
      setLastEvaluatedKey(result.last_evaluated_key);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setLastEvaluatedKey(null);
    setData([]);
    setLoadMoreIsVisible(true);
    fetchData();
  }, [preferences.pageSize, statusFilter]);

  const tableHeader = (
    <FullPageHeader
      title="My requests"
      actions={<></>}
      />
  );

  return (
    <>
      <BaseTable
        columnDefinitions={COLUMN_DEFINITIONS}
        items={data}
        loading={isLoading}
        statusOptions={STATUS_OPTIONS}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        onFetchData={fetchData}
        preferences={preferences}
        loadMoreIsVisible={loadMoreIsVisible}
        tableHeader={tableHeader}
        selectionType="none"
      />
    </>
  );
}

export default UserRequestsTable;